export default __webpack_public_path__ + "static/media/background-ornement.b67f8986.svg";